import React from 'react'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

import {FacilitiesGridLoader} from '../Facilities'
import {MAXIMUM_POPULAR_FACILITIES} from './constants'

export const PopularFacilitiesLoading = () => {
  const {isMobile} = useDeviceLayout()
  if (isMobile)
    return <FacilitiesGridLoader items={MAXIMUM_POPULAR_FACILITIES} />
  return (
    <div>
      <FacilitiesGridLoader
        variant="secondary"
        items={MAXIMUM_POPULAR_FACILITIES}
      />
      <SkeletonLoader width={100} height={28} marginTop={16} />
    </div>
  )
}
